<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="divContainer" style="top:1px;">
          <div class="col-12 col-sm-12">
            <div class="card card-primary card-outline card-outline-tabs">
              <div class="card-body">
                <div>
                  <button type="button" id="btnLoadList" (click)="GetVendorConfigList()" style="display:none">Get</button>
                  <button type="button" (click)="show()" id="btn_AddNew" style="display:none">
                    Add
                  </button>
                  <table #dataTable class="display" style="width:100%"></table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="button" id="btnDeleteDT" (click)="Delete()" style="display:none">Delete</button>
        <button type="button" id="btnDeleteConfirm" (click)="DeleteConfirm()" style="display:none">Delete Confirm</button>

        <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-lg custome-modal">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{title}}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
              </div>
              <div class="modal-body" style="overflow-y:scroll; overflow-x:hidden">
                <form #form="ngForm">

                  <div class="row">
                    <div class="col-md-4">
                      <!--text input-->
                      <div class="form-group">
                        <label>Vendor</label><span class="required">*</span>
                        <select class="form-control" id="ddlvendorID" (change)="GetPublisherList(0,0)">
                          <option value="0" selected="selected">Select</option>
                          <option *ngFor="let item of vendorList" value={{item.ID}}>
                            {{item.VendorName}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Publisher</label><span class="required">*</span>
                        <select class="form-control" id="ddlpublisherID" (change)="GetJournalListByPublisherID(0,null)">
                          <option value="0" selected="selected">Select Publisher</option>
                          <option *ngFor="let item of publisherList" value={{item.ID}} [selected]="item.ID==PublisherIDPop">{{item.PublisherName}}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Journal</label>
                        <select class="form-control select2" id="ddlJournalID" multiple>
                          <option *ngFor="let item of journalList" value={{item.ID}} [selected]="JournalIDPop.indexOf(item.ID) !== -1">{{item.JournalTitle}} </option>
                        </select>
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Notification To EMailID</label><span class="required">*</span>
                        <input class="form-control" type="email" id="txtEMailID" placeholder="" maxlength="25" autocomplete="off" (change)="emailidOnly($event)">
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Notification CC EMailID</label>
                        <input class="form-control" type="email" id="txtCCEMailID" placeholder="" maxlength="25" autocomplete="off" (change)="emailidOnly($event)">
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Notification BCC EMailID</label>
                        <input class="form-control" type="email" id="txtBCCEMailID" placeholder="" maxlength="25" autocomplete="off" (change)="emailidOnly($event)">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-5">
                      <div class="form-group">
                        <label>Process Type</label><span class="required">*</span>
                        <select class="form-control select2" id="ddlProcessType" (change)="ShowTabByProcessType()">
                          <option value="Download" selected="selected">Download</option>
                          <option value="Upload">Upload</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="form-group">
                        <label>File Location</label><span class="required">*</span>
                        <select class="form-control select2" id="ddlDownloadType" (change)="ValidateFormByDownload()">
                          <option value="0" selected="selected">Select</option>
                          <option value="S3" selected="selected">S3</option>
                          <option value="FTP">FTP</option>
                          <option value="SFTP">SFTP</option>
                        </select>
                      </div>
                    </div>
                  </div>


                  <div class="tab-content">
                    <div id="DownloadTab" class="tab-pane fade in show">
                      <div id="DS3">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Bucket Name</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtDBucketName" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Access Key</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtDAccessKey" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Security Key</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtDSecurityKey" placeholder="">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>Endpointregion</label>
                              <input class="form-control" type="text" id="txtDEndpointregion" placeholder="">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>Remarks</label>
                              <input class="form-control" type="text" id="txtDRemarks" placeholder="">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div id="DFTP">
                        <div class="row">
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Host</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtDFHost" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>User Name</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtDFUserName" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Password</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtDFPassword" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Port</label><span class="required">*</span>
                              <input class="form-control" type="number" id="txtDFPort" placeholder="">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>Remarks</label>
                              <input class="form-control" type="text" id="txtDFRemarks" placeholder="">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div id="DSFTP">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Host</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtDSFHost" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>User Name</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtDSFUserName" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Password</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtDSFPassword" placeholder="">
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Port</label><span class="required">*</span>
                              <input class="form-control" type="number" id="txtDSFPort" placeholder="">
                            </div>
                          </div>


                          <div class="col-md-4">
                            <div class="form-group">
                              <label for="Txtkeyfile">Key File</label><span class="required">*</span>
                              <input type="file" (change)="onFileChange($event)" id="DSFfile-input" class="form-control">
                            </div>
                          </div>

                          <div class="col-md-2">
                            <div class="form-group">
                              <button type="button" class="btn btn-outline-info waves-effect waves-light" style="margin-top: 30px;" id="btnDSFUpload" (click)="uploadFile()">Upload</button>
                            </div>
                          </div>
                          <div class="col-md-2" style="margin-top: 22px" id="divmsg">
                            <div *ngIf="messages.length > 0">
                              <span *ngFor="let msg of messages" style="margin-left: 50px;">
                                {{msg}}
                              </span>
                            </div>
                          </div>

                        </div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label for="TxtDfile">Uploaded file name</label>
                              <a id="divDfilename">
                                <button type="button" id="btnDDownload" (click)="DownloadFile()">{{ DFname }}</button>
                              </a>
                            </div>
                          </div>

                          <div class="col-md-8">
                            <div class="form-group">
                              <label>SFTP Folder Path</label>
                              <input class="form-control" type="text" id="txtDSFFolderPath" placeholder="" disabled>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>Remarks</label>
                              <input class="form-control" type="text" id="txtDSFRemarks" placeholder="">
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div id="UploadTab" class="tab-pane fade">
                      <div class="row">
                        <div class="col-sm-5">
                          <div class="form-group">
                            <label>File Location</label><span class="required">*</span>
                            <select class="form-control select2" id="ddlUploadType" (change)="ValidateFormByUpload()">
                              <option value="0" selected="selected">Select</option>
                              <option value="S3" selected="selected">S3</option>
                              <option value="FTP">FTP</option>
                              <option value="SFTP">SFTP</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div id="US3">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Bucket Name</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtUBucketName" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Access Key</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtUAccessKey" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Security Key</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtUSecurityKey" placeholder="">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>Endpointregion</label>
                              <input class="form-control" type="text" id="txtUEndpointregion" placeholder="">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>Remarks</label>
                              <input class="form-control" type="text" id="txtURemarks" placeholder="">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div id="UFTP">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Host</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtUFHost" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>User Name</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtUFUserName" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Password</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtUFPassword" placeholder="">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Port</label><span class="required">*</span>
                              <input class="form-control" type="number" id="txtUFPort" placeholder="">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>Remarks</label>
                              <input class="form-control" type="text" id="txtUFRemarks" placeholder="">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div id="USFTP">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Host</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtUSFHost" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>User Name</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtUSFUserName" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Password</label><span class="required">*</span>
                              <input class="form-control" type="text" id="txtUSFPassword" placeholder="">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Port</label><span class="required">*</span>
                              <input class="form-control" type="number" id="txtUSFPort" placeholder="">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label for="Txtkeyfile">Key File</label><span class="required">*</span>
                              <input type="file" (change)="onFileChange($event)" id="USFfile-input" class="form-control">
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="form-group">
                              <button type="button" class="btn btn-outline-info waves-effect waves-light" style="margin-top: 30px;" id="btnupload" (click)="uploadFile()">Upload</button>
                            </div>
                          </div>
                          <div class="col-md-2" style="margin-top: 22px" id="divmsg">
                            <div *ngIf="messages.length > 0">
                              <span *ngFor="let msg of messages" style="margin-left: 50px;">
                                {{msg}}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label for="Txtupfile">Uploaded file name</label>
                              <a id="divUfilename">
                                <button type="button" id="btnUDownload" (click)="DownloadFile()">{{ UFname }}</button>
                              </a>

                            </div>
                          </div>
                          <div class="col-md-8">
                            <div class="form-group">
                              <label>SFTP Folder Path</label>
                              <input class="form-control" type="text" id="txtUSFFolderPath" placeholder="" disabled>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>Remarks</label>
                              <input class="form-control" type="text" id="txtUSFRemarks" placeholder="">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <!-- Modal footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" (click)="ClearAllData()">Close</button>
                <button type="button" class="btn btn-outline-info waves-effect waves-light" (click)="UpdateVendorConfig()">Submit</button>&nbsp;&nbsp;&nbsp;
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
